import { combineEpics } from 'redux-observable'
import * as starter from './starter'
import * as contact from './contact'

export const rootEpic = combineEpics(
  starter.loadingEpic,
  contact.sendEmail
)
